const models = {
  portugues: {
    title: 'Modelos',
    subTitle: 'Conheça as mais belas gatas do Bella da Semana. Confira abaixo as últimas modelos:',
    placeHolderSelect: 'Filtrar por nome',
    SeeAllModels: 'Veja todas modelos:',
    labelPagination: 'de',
    shootModel: 'Veja o ensaio',
    featuredModels: 'Modelos em destaque:',
    lastModels: 'Últimas Modelos',
    mostViewed: 'Mais Acessadas',
    models: 'Modelos',
    seeAllModels: 'Acesse todos os vídeos',
    videosTitle: 'Vídeos',
    seeAllVideosPrefix: 'Acesse todos os',
    seeAllVideosHighlight: 'Vídeos',
    categories: 'CATEGORIAS',
    nextPage: 'PRÓXIMA PÁGINA',
    prevPage: 'PÁGINA ANTERIOR'
  },
  ingles: {
    title: 'Models',
    subTitle: 'Meet the most beautiful Bella Club babes. Check out the latest models below:',
    placeHolderSelect: 'Filter by name',
    SeeAllModels: 'See all models:',
    labelPagination: 'of',
    shootModel: 'See the shoot',
    featuredModels: 'Featured Models:',
    lastModels: 'Last Models',
    mostViewed: 'Most Viewed',
    models: 'Models',
    seeAllModels: 'Access all videos',
    videosTitle: 'Videos',
    seeAllVideosPrefix: 'Access all',
    seeAllVideosHighlight: 'Videos',
    categories: 'CATEGORIES',
    nextPage: 'NEXT PAGE',
    prevPage: 'PREVIOUS PAGE'
  }
}

export default models
